import { Type } from "@sinclair/typebox";
import { ConditionGroup, TranslatedString } from "./common";
import { CustomCard, FlowLinkCard, HelpContentCard, LinkListCard, MessageHistoryCard, NewsListCard, SubmitTicketCard, } from "./card-components";
const BaseRoute = Type.Object({
    id: Type.String(),
});
export const HomeRoute = Type.Composite([
    BaseRoute,
    Type.Object({
        type: Type.Literal("HomeRoute"),
        greetingMessage: Type.Optional(TranslatedString),
        cards: Type.Optional(Type.Array(Type.Object({
            condition: Type.Optional(ConditionGroup),
            card: Type.Union([
                FlowLinkCard,
                NewsListCard,
                HelpContentCard,
                LinkListCard,
                CustomCard,
                SubmitTicketCard,
            ]),
        }))),
    }, {
        title: "HomeRoute",
    }),
]);
export const MessagesRoute = Type.Composite([
    BaseRoute,
    Type.Object({
        type: Type.Literal("MessagesRoute"),
        permissions: Type.Optional(Type.Object({
            usergroupIds: Type.Optional(Type.Array(Type.String())),
            excludedUsergroupIds: Type.Optional(Type.Array(Type.String())),
        })),
        cards: Type.Optional(Type.Array(Type.Object({
            condition: Type.Optional(ConditionGroup),
            card: Type.Union([FlowLinkCard, MessageHistoryCard]),
        }))),
    }, {
        title: "MessagesRoute",
    }),
]);
export const HelpcenterRoute = Type.Composite([
    BaseRoute,
    Type.Object({
        type: Type.Literal("HelpcenterRoute"),
        permissions: Type.Optional(Type.Object({
            usergroupIds: Type.Optional(Type.Array(Type.String())),
            excludedUsergroupIds: Type.Optional(Type.Array(Type.String())),
        })),
        cards: Type.Optional(Type.Array(Type.Object({
            condition: Type.Optional(ConditionGroup),
            card: HelpContentCard,
        }))),
    }, {
        title: "HelpcenterRoute",
    }),
]);
export const NewsRoute = Type.Composite([
    BaseRoute,
    Type.Object({
        type: Type.Literal("NewsRoute"),
        permissions: Type.Optional(Type.Object({
            usergroupIds: Type.Optional(Type.Array(Type.String())),
            excludedUsergroupIds: Type.Optional(Type.Array(Type.String())),
        })),
        cards: Type.Optional(Type.Array(Type.Object({
            condition: Type.Optional(ConditionGroup),
            card: Type.Union([NewsListCard]),
        }))),
    }, {
        title: "NewsRoute",
    }),
]);
export const Route = Type.Union([HomeRoute, MessagesRoute, HelpcenterRoute, NewsRoute]);
export const RoutePath = Type.Union([
    Type.Literal("home"),
    Type.Literal("help"),
    Type.Literal("messages"),
    Type.Literal("news"),
]);
export const mapRouteTypeToPath = {
    HomeRoute: "home",
    HelpcenterRoute: "help",
    MessagesRoute: "messages",
    NewsRoute: "news",
};
